import { parseUserIdFromRef } from 'core/utils/checklistEventAssignment';

export const toUserIri = (userRef: unknown): string | null => {
	const id = parseUserIdFromRef(userRef);
	if (id != null) return `/api/users/${id}`;
	if (typeof userRef === 'string' && userRef.trim()) return userRef;
	if (userRef && typeof userRef === 'object') {
		const iri = (userRef as { '@id'?: string })['@id'];
		if (iri) return iri;
	}
	return null;
};

export const isSameUserRef = (left: unknown, right: unknown): boolean => {
	const leftId = parseUserIdFromRef(left);
	const rightId = parseUserIdFromRef(right);
	if (leftId != null && rightId != null) return leftId === rightId;
	return false;
};

export const findEmployeeOption = <T>(employees: T[] | null | undefined, employeeRef: unknown): T | undefined => {
	if (!employeeRef || !employees?.length) return undefined;
	return employees.find((employee) => isSameUserRef(employee, employeeRef));
};

export const toEmployeeOption = (employee: any) => {
	const id = parseUserIdFromRef(employee);
	return {
		...employee,
		id: id ?? employee?.id,
		'@id': toUserIri(employee) || employee?.['@id'],
		firstName: employee?.firstName || employee?.first_name || '',
		lastName: employee?.lastName || employee?.last_name || '',
	};
};

export const withAssignedEmployeeOption = (
	employees: any[] = [],
	assignedEmployee: unknown,
	houseShiftOption: any
) => {
	const assignedOption =
		assignedEmployee && parseUserIdFromRef(assignedEmployee)
			? toEmployeeOption(assignedEmployee)
			: null;
	const alreadyListed = assignedOption
		? findEmployeeOption(employees, assignedOption)
		: undefined;

	if (assignedOption && !alreadyListed) {
		return [houseShiftOption, assignedOption, ...employees];
	}

	return [houseShiftOption, ...employees];
};
